import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: var(--space-200);
`

export const PillItem = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  outline: none;
  border-radius: var(--radius-brand);
  padding: var(--space-150) var(--space-250);

  gap: var(--space-250);

  color: var(--text-primary);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-300);

  ${(props) => css`
    background: ${props.$active ? 'var(--bg-secondary)' : 'transparent'};
  `};

  &:hover {
    background: var(--bg-secondary-hover);
  }
`
